import { connect } from "react-redux";
import { QuestionTableAdapter as Component } from "./QuestionTableAdapter";
import {
  setPredictedQuestionTableData,
  questionTableCellUpdate,
  questionTableSubmit,
} from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps() {
  return {
    //gelDragDropPrediction: state.notebook.levelData.RESULTS.components[findIndex(state.notebook.levelData.RESULTS.components, {type: "GEL_DRAG_DROP_QUESTION"})],
    //predictedQuestionTableData: state.notebook.protocolSection?.predictedQuestionTableData,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setPredictedQuestionTableData: (data) => {
      dispatch(setPredictedQuestionTableData(data));
    },
    questionTableCellUpdate: (data) => {
      dispatch(questionTableCellUpdate(data));
    },
    questionTableSubmit: (data) => {
      dispatch(questionTableSubmit(data));
    },
  };
}

export const QuestionTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
